import { render } from "./ScoringLadder.vue?vue&type=template&id=5479212c&scoped=true"
import script from "./ScoringLadder.vue?vue&type=script&lang=js"
export * from "./ScoringLadder.vue?vue&type=script&lang=js"

import "./ScoringLadder.vue?vue&type=style&index=0&id=5479212c&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0a0cda5bfc5ca6053-1/assemble-sports/universityoftasmania-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5479212c"]])

export default __exports__